import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SuperAdminService } from '@core/services/super-admin.service';
import { DriverService } from '../driver/services/driver.service';
import { BookingFlowV1Service } from '../booking-flow-v1/components/services/booking-flow-v1.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { PAY_REPAY_PAYMENT_CONFIRMATION_MSG, USER_ROLES } from '@shared/constant/shared.constant';
import { GroupUserService } from '@core/services/group-user.service';
import { ReattemptBookingModalComponent } from '../reattempt-booking-modal/reattempt-booking-modal.component';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-pay-repay-modal',
  templateUrl: './pay-repay-modal.component.html',
  styleUrls: ['./pay-repay-modal.component.scss']
})
export class PayRepayModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  bookingId: string = '';
  driverId: string = '';
  invoiceId:string = '';
  bookingDetails: any;
  paymentCardDetails: any;
  paymentBankDetails: any;
  paymentMethodSelected:any;
  isPreferredPaymentSelected: boolean = true;
  selectedPaymentMethod: any = null;
  isPrefereedPaymentMethod:boolean = false;
  prefereedPaymentMethodId: string = null;
  updateBookindDetailsValue:any;
  paymentMethodDetails:any
  isPaymentMethodValid: boolean = false;
  bookingType:boolean = false;
  previouslySelectedPaymentMethod: any = null;
  previousPaymentMethodCardAch:any = null;
  viewMore:boolean = false;
  displayedPaymentMethods: any[] = [];
  customInvoiceDetails:any;
  role: string;
  userRoles = USER_ROLES;
  isSubmitButtonClicked:boolean = false;
  bookingEndDate:string = '';
  isScheduleDateTimeValid: boolean = false;
  scheduleDateTimeValue: string = '';
  isScheduleCancelBookingMessage:boolean = true;
  roleName: string = '';
  timeZone: string = '';
  bookingScheduledDate:string = '';
  isScheduleOptionShow:boolean = false;

  constructor(
    public readonly config: DynamicDialogConfig,
    private readonly superAdminService: SuperAdminService,
    private readonly driverService: DriverService,
    private readonly bookingFlowV1Service: BookingFlowV1Service,
    private readonly ref: DynamicDialogRef,
    private readonly dialogControlService:DialogControlService,
    private readonly groupUserService: GroupUserService,
    private readonly encryptStorage: EncryptionStorageService
  ) {}

  ngOnInit() {
    this.bookingId = this.config.data.id;
    this.driverId = this.config.data.driverId;
    this.bookingType = this.config.data.bookingType;
    this.invoiceId = this.config?.data?.invoiceId;
    this.role = this.config?.data?.role;
    this.roleName = this.encryptStorage.getItem('roleName') || '';
    this.timeZone = this.config?.data?.timeZone || '';
    this.bookingScheduledDate = this.config?.data?.bookingScheduledDate;
    this.isScheduleOptionShow = this.config?.data?.isScheduleOptionShow;

    if(this.bookingId){
      this.getBookingDetailsByID();
    }
    if(this.invoiceId){
      this.getCustomInvoiceDetailById();
    }
  }

  schdeuleDateTimeData(event) {
    this.isScheduleDateTimeValid = event?.isScheduleDateTime;
    this.scheduleDateTimeValue = event?.dateTime;
    this.isSubmitButtonClicked = event?.isSubmitButtonClicked;
  }

  getBookingDetailsByID() {
    
    const { groupUserService, superAdminService,role,userRoles } = this;
    const service = role === userRoles.GROUP_USER ? groupUserService : superAdminService;
    const method = role === userRoles.GROUP_USER ? 'getGroupBookingDetailById' : 'getBookingDetailById';

    service[method](this.bookingId)
     .pipe(
            autoUnsubWith(this.destroyRef)
          )
    .subscribe({
      next: (response) => {
        this.bookingDetails = response;
        if (this.bookingDetails?.bookingPaymentMethodId === null && this.bookingDetails.paymentMethodType != null) {
          this.isPreferredPaymentSelected = false;
          if (this.bookingDetails.paymentMethodType === 1) {
            this.selectedPaymentMethod = 1;
            this.UpdateBookingByOffer(this.selectedPaymentMethod)
          } 
          
          if(this.bookingDetails.paymentMethodType === 2) {
            this.selectedPaymentMethod = 2;
            this.UpdateBookingByOffer(this.selectedPaymentMethod)
          }
        }

        this.getAllPaymentList(this.driverId);
        
      }, error: (_error) => {
        this.bookingDetails = null;
      }
    })
  }

  getCustomInvoiceDetailById() {
    let id = this.invoiceId;
    this.superAdminService.getCustomInvoiceDetailById(id)
     .pipe(
        autoUnsubWith(this.destroyRef)
      )
    .subscribe({
      next: (response) => {
        this.customInvoiceDetails = response;
        this.getAllPaymentList(this.driverId)
      }
    })
  }

  validatePaymentMethod() {
    const isValid =
      (this.isPreferredPaymentSelected && this.paymentMethodSelected) ||
      (!this.isPreferredPaymentSelected && this.selectedPaymentMethod !== null);

    this.isPaymentMethodValid = !isValid;

    return isValid;
  }

getAllPaymentList(DriverId) {
    this.driverService.getAllPatmentMethodsList(DriverId)
     .pipe(
        autoUnsubWith(this.destroyRef)
      )
    .subscribe({
      next: (response) => {
        const cards = response.data['cards'] || [];
        let banks = response.data['banks'] || [];

        if (this.bookingDetails?.bookingType === 0) {
          banks = []; // Remove bank objects if bookingType is 0
        }
        let defaultPayment
        if (this.bookingId) {
          defaultPayment = [...cards, ...banks].find(payment => payment.id === this.bookingDetails.bookingPaymentMethodId);
        }
        if (this.invoiceId) {
          if (this.customInvoiceDetails.paymentMethodId != null) {
            defaultPayment = [...cards, ...banks].find(payment => payment.id === this.customInvoiceDetails.BookingPaymentMethodId);
          } else {
            defaultPayment = [...cards, ...banks].find(payment => payment.isDefaultPaymentMethod);
          }
        }

        if (this.bookingDetails?.bookingType === 0) {
          defaultPayment = null; // Do not set default payment method
        }

        if (defaultPayment?.type === 'card') {
          this.paymentMethodDetails = [...cards, ...banks]; // Show cards first
        } else if (defaultPayment?.type === 'us_bank_account') {
          this.paymentMethodDetails = [...banks, ...cards]; // Show banks first
        } else {
          this.paymentMethodDetails = [...cards, ...banks]; // Default order if no default payment
        }
        if (defaultPayment) {
          this.paymentMethodDetails = this.paymentMethodDetails.filter(p => p !== defaultPayment);
          this.paymentMethodDetails.unshift(defaultPayment);
        }

        this.paymentMethodSelected = this.bookingDetails?.bookingType === 0 ? null : defaultPayment;
        this.updateDisplayedPayments();
        this.prefereedPaymentMethodId = this.paymentMethodSelected?.id
        if(this.isPreferredPaymentSelected){
          this.UpdateBookingByOffer(((this.paymentMethodSelected) && this.paymentMethodSelected.type ==='card') ? 1: 2)
        }

},
      error: (_error) => {  
        this.displayedPaymentMethods = [];
        this.isPreferredPaymentSelected = false;
      }
    });
  }

  viewMoreToggal(){
    this.viewMore = !this.viewMore;
    this.updateDisplayedPayments();
  }

  updateDisplayedPayments() {
    this.displayedPaymentMethods = this.viewMore
      ? this.paymentMethodDetails // Show all if "View More" is clicked
      : this.paymentMethodDetails.slice(0, 2); // Show only first 2 items initially
  }

  onPaymentChange(event) {
    if (this.isPreferredPaymentSelected) {
      this.paymentMethodSelected = event;
      this.prefereedPaymentMethodId = event.id;
    }
    this.validatePaymentMethod();
    this.UpdateBookingByOffer(event.type === 'card' ? 1 :2);
  }

  getSelectedPaymentMethod(data) {
    this.previousPaymentMethodCardAch = data;
    this.selectedPaymentMethod = data;
    this.validatePaymentMethod();
    this.UpdateBookingByOffer(this.selectedPaymentMethod);
  }
  onPreferredCheck(data){
    this.isPaymentMethodValid = false;
    if (!data) {
      this.previouslySelectedPaymentMethod = this.paymentMethodSelected;
      this.prefereedPaymentMethodId = null;
      this.UpdateBookingByOffer(null);
      if(this.previousPaymentMethodCardAch !=null){
        this.UpdateBookingByOffer(this.previousPaymentMethodCardAch);
      }

    } else {
      if (this.previouslySelectedPaymentMethod) {
        this.paymentMethodSelected = this.previouslySelectedPaymentMethod;
        this.prefereedPaymentMethodId = this.previouslySelectedPaymentMethod.id;
        this.UpdateBookingByOffer(this.previouslySelectedPaymentMethod.type === 'card' ? 1 : 2);
      }
    }

  }

  UpdateBookingByOffer(paymentMethod) {
    if(this.bookingType){
      
      let data = {
        bookingId: this.bookingId,
          useCredit: this.bookingDetails?.usedCredit > 0 ?true : false,
        useOffer: this.bookingDetails.offer,
        paymentMethod: paymentMethod,
        isPrefereedPaymentMethod:this.isPreferredPaymentSelected ? true : false,
          prefereedPaymentMethodId:this.isPreferredPaymentSelected ? this.prefereedPaymentMethodId: null,
        isExemptTaxesAndFees: this.bookingDetails?.exemptTaxesAndFees > 0 ? true : false,
      }
      this.bookingFlowV1Service.UpdateBookingByOffer(data)
        .pipe(
          autoUnsubWith(this.destroyRef)
        ).subscribe({
          next: (response: any) => {
            this.updateBookindDetailsValue = response;
          }
        })
    }

  }

  isPreferredPaymentSelectedPayment() {
    this.isSubmitButtonClicked = true;
    if (this.isPreferredPaymentSelected) {
      if (this.isScheduleDateTimeValid) {
        return;
      }
      this.validatePaymentMethod();
      if (this.isPaymentMethodValid) {
        return
      }
      this.defaultPaymentMethodConfirmation();
      this.ref.close();
    } else {
      this.createPaymentSession();
    }
  }

  createPaymentSession() {
    this.validatePaymentMethod();
    if (this.isPaymentMethodValid) {
      return
    }
    
    let data = {
      bookingId: this.bookingType ? this.bookingId : null,
      invoiceId: !this.bookingType ? this.invoiceId : null,
      paymentMethodType: this.selectedPaymentMethod
    }
    this.driverService.paymentUrlMethod(data)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (res: any) => {
          if (res.url) {
          if (res.isStripeInvoiceUrl) {
            window.open(res.url, "_blank"); // Open in a new tab
            this.close();
          } else {
            window.location.href = res.url; // Redirect in the same tab
          }
        }
      }
    })
  }

  close() {
    this.ref.close();
  }

  defaultPaymentMethodConfirmation() {
    this.dialogControlService.openDialog(ReattemptBookingModalComponent, {
      styleClass: 'reattempt-model',
      data: {
        headerText: 'Payment',
        bodyText: PAY_REPAY_PAYMENT_CONFIRMATION_MSG,
        reAttemptPopup: false,
        prefereedPaymentMethodId: this.prefereedPaymentMethodId,
        bookingType: this.bookingType,
        bookingId: this.bookingId,
        IsPaymentDoInstantly: true,
        scheduleDateTimeValue: this.scheduleDateTimeValue,
        isPreferredPaymentSelected: this.isPreferredPaymentSelected,
        invoiceId: this.invoiceId,
        isFunctionAttempted: 2,
      }
    });
  }
}
